"use client";

import { useTenancy } from "./tenancy-context";

/** Base path for the active project, e.g. /projects/ws-prod */
export function useWsBase() {
  const { projectId } = useTenancy();
  return `/projects/${projectId}`;
}

/** Build a project-scoped href: wp("/targets") -> /projects/ws-prod/targets */
export function useProjectPath() {
  const base = useWsBase();
  return (seg = "") => `${base}${seg}`;
}
